import { PayloadAction } from '@reduxjs/toolkit';
import { TermAndConditionModel } from '../../types';
import { createAppSlice } from './createAppSlice.ts';

export interface TermsSliceState {
  terms?: TermAndConditionModel;
}

const initialState: TermsSliceState = {
  terms: undefined,
};

export const termsSlice = createAppSlice({
  name: 'terms',
  initialState,
  reducers: (create) => ({
    setTerms: create.reducer(
      (state, action: PayloadAction<TermAndConditionModel | undefined>) => {
        state.terms = action.payload;
      }
    ),
  }),
  selectors: {
    selectTerms: (terms) => terms.terms,
  },
});

export const { setTerms } = termsSlice.actions;

export const { selectTerms } = termsSlice.selectors;
